/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./listWebhooks.defs.js";
export { main as default } from "./listWebhooks.defs.js";
